import fr from "./lang/fr.js";
import en from "./lang/en.js";
import es from "./lang/es.js";
import de from "./lang/de.js";
import el from "./lang/el.js";
import fi from "./lang/fi.js";
import it from "./lang/it.js";
import pt from "./lang/pt.js";
import sv from "./lang/sv.js";
import zh from "./lang/zh.js";
import zh_HK from "./lang/zh-HK.js"

export let allStrings = {
  en,
  fr,
  es,
  de,
  el,
  fi,
  it,
  pt,
  sv,
  zh,
  ["zh-HK"]: zh_HK,
};
